import moment from 'moment';

const secondsInADay = new Date(2020, 1, 15).getTime() - new Date(2020, 1, 14).getTime();

const MONTH_SHORT_VALUE = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getDateStringForMonthValue = monthValue => {
  const monthDate = getMonthStartTime(monthValue);
  return `${MONTH_SHORT_VALUE[monthDate.getMonth()]}-${monthDate
    .getFullYear()
    .toString()
    .substr(2)}`;
};

export const getDayStartTime = dateObj => {
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth();
  const date = dateObj.getDate();
  return new Date(year, month, date, 0, 0, 0);
};

export const getCurrentDayStartTime = () => getDayStartTime(new Date());

export const getNDaysPriorStartTime = priorDays => {
  const curDayStartTime = getCurrentDayStartTime().getTime();

  const priorDaysSeconds = priorDays * secondsInADay;
  return new Date(curDayStartTime - priorDaysSeconds);
};

export const getMonthStartTime = monthsFromToday => {
  const monthValue = monthsFromToday % 12;
  const curMonth = new Date().getMonth();
  const isPreviousYear = curMonth < monthValue;
  const newMonthValue = isPreviousYear ? curMonth - monthValue + 12 : curMonth - monthValue;

  return new Date(isPreviousYear ? new Date().getFullYear() - 1 : new Date().getFullYear(), newMonthValue, 1, 0, 0, 0);
};

export const getMonthsGap = (date1, date2) => {
  const month1 = date1 instanceof Date ? date1.getMonth() : null;
  const month2 = date2 instanceof Date ? date2.getMonth() : null;

  if (month1 == null || month2 == null) {
    return null;
  }

  return month1 >= month2 ? month1 - month2 : month1 - month2 + 12;
};

export const sortByDate = (array, dateFieldName) => {
  array.sort((o1, o2) => {
    const d1 = o1[dateFieldName];
    const d2 = o2[dateFieldName];

    return d2.getTime() - d1.getTime();
  });
};

export const getLocalTimeObj = (hour = 0, minute = 0, second = 0) => {
  const dateObj = new Date();
  const month = dateObj.getMonth();
  const date = dateObj.getDate();

  return new Date( dateObj.getFullYear(), month, date, hour, minute, second);
};

export const getFormElementSpecificDateValue = (value) => {
  const dateObj = new Date(value);
  return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}T${dateObj.getHours()}:${dateObj.getSeconds()}`;
}

export const getNHoursPriorTime = (hour) => {
  return new Date(new Date().getTime() - hour * (60 * 60 * 1000));
}

export const getTimeDuration = (startTime, endTime) => {
  if (startTime instanceof Date && endTime instanceof Date) {
    const startMoment = moment(startTime);
    const endMoment = moment(endTime);
    return endMoment.to(startMoment, true);
  }

  return "NA";
}
